import type { IUserStore } from '~/composables/account/interface'
import type { PromotionUser } from '~/composables/promotion/interface'
import type { GameSlotJackpotResponseData } from '~/stores/jackpot.store.ts'

interface IGpWalletData {
  balance: number
  user_id: number
}

interface IBalance {
  balance: number
  user_id: number
}

interface IDataMessageSocket {
  balance?: IBalance
  code?: number | string
}

export interface IDataMessageSocketResponse {
  data?: IDataMessageSocket | IDataMessageSocket[]
  error?: string
  username?: string
  currentUser: IUserStore
  gpWalletData?: IGpWalletData[]
  code?: number | string
}

export interface IJackpotSocketResponse {
  data: GameSlotJackpotResponseData | null
}

export interface IDataJackpotBannerSocketResponse {
  data?: JackpotBanner[] | null
}

export interface JackpotBanner {
  id: string
  name: string
  configValue: number
  currentValue: number
  on: boolean
}
export interface CreditResponse {
  betAccount: string
  betCredit: number
  credit: number
}

export interface IPromotionUserSocketResponse {
  data: PromotionUser | null
}

export enum ResponseStatus {
  OK = 'OK',
  AUTHENTICATION_REQUIRED_ERROR = 'AUTHENTICATION_REQUIRED_ERROR',
  WRONG_CURRENT_PASS = 'WRONG_CURRENT_PASS',
  INVALID_PACKAGE_ID_INVOICE_ERROR = 'INVALID_PACKAGE_ID_INVOICE_ERROR',
  INSUFFICIENT_EXCHANGE_PACKAGE_ERROR = 'INSUFFICIENT_EXCHANGE_PACKAGE_ERROR',
  LOGIN_FAILED_MANY_TIMES_ERROR = 'LOGIN_FAILED_MANY_TIMES_ERROR',
  USER_EXISTED_ERROR = 'USER_EXISTED_ERROR',
  EXISTED_DISPLAYNAME_ERROR = 'EXISTED_DISPLAYNAME',
  OVER_RATE_LIMIT_PER_DAY_TPAY = 'OVER_RATE_LIMIT_PER_DAY_TPAY',
  LIMIT_REQUEST = 'LIMIT_REQUEST'
}

export interface DropdownItem {
  label?: string
  value?: string | number
  textClassStatus?: string
  isDisabled?: boolean
  icon?: string
  image?: string
  key?: string
  iconGray?: string
  count?: number
  labelStatement?: string
  type?: string
}

export enum CasinoPerPage {
  DEFAULT = 12
}
